var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8708 18.2189H20.9101C22.0588 18.2189 22.7856 17.5873 22.7856 16.5723C22.7856 15.6153 22.0588 14.9258 20.9101 14.9258H16.8708C16.737 14.9258 16.6226 15.0403 16.6226 15.156V17.9887C16.6406 18.1224 16.7358 18.2189 16.8708 18.2189ZM16.8708 24.746H21.0438C22.3264 24.746 23.0918 24.0951 23.0918 22.9464C23.0918 21.9507 22.365 21.1467 21.0438 21.1467H16.8708C16.737 21.1467 16.6226 21.2612 16.6226 21.377V24.4977C16.6406 24.6508 16.7358 24.746 16.8708 24.746Z",
    fill: "#34313F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6489 0.0703672L19.7035 11.9771H21.6563C24.6999 11.9771 26.4995 13.8912 26.4995 15.9777C26.4995 17.6243 25.3894 18.8297 24.202 19.3661C24.0104 19.4433 24.0104 19.7108 24.2213 19.7867C25.599 20.3231 26.5754 21.7587 26.5754 23.4426C26.5754 25.816 24.9867 27.7108 21.9045 27.7108H13.444C13.3102 27.7108 13.1958 27.5963 13.1958 27.4806V18.4643L0.0823887 31.5211C-0.0899863 31.6935 0.0245016 31.9996 0.274059 31.9996H31.802C31.9164 31.9996 32.0129 31.9044 32.0129 31.7886V0.242742C32.0695 0.0317757 31.802 -0.0827121 31.6489 0.0703672Z",
    fill: "#34313F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group-4.d1c42d2c28f50b975615408ad9070a37.svg";
export { ForwardRef as ReactComponent };